import { askAboutAndReveal } from "../../../state/chatActions";
import type { EthocaAlert, MerchantSummary } from "../../../data/types";
import { fmtEur } from "./format";
import styles from "./EthocaAlertQueue.module.css";

interface EthocaAlertQueueProps {
  alerts: EthocaAlert[];
  merchants: MerchantSummary[];
  limit?: number;
}

export function EthocaAlertQueue({
  alerts,
  merchants,
  limit = 8,
}: EthocaAlertQueueProps) {
  const byId = new Map(merchants.map((m) => [m.id, m]));
  const queue = alerts.slice(0, limit);
  const pending = queue.filter((a) => a.status === "pending").length;

  return (
    <div className={styles.card}>
      <header className={styles.header}>
        <span className={styles.title}>ethoca / cdrn queue</span>
        <span className={styles.muted}>
          {pending} pending · {queue.length} in view
        </span>
      </header>
      <ul className={styles.list}>
        {queue.map((a) => {
          const m = byId.get(a.merchantId);
          const stateClass =
            a.status === "pending"
              ? styles.pending
              : a.status === "acted"
                ? styles.acted
                : styles.expired;
          return (
            <li key={a.id}>
              <button
                type="button"
                className={`${styles.item} ${stateClass}`}
                onClick={() =>
                  askAboutAndReveal(
                    `break down ethoca alert ${a.id} on ${m?.name ?? a.merchantId}: card ••${a.cardLast4}, ${fmtEur(a.amountEur)}, received ${a.receivedAt}, status ${a.status}${a.action ? ` (${a.action})` : ""}. why did we ${a.action ?? "not act yet"}, and what's the expected outcome?`,
                    "intelligence",
                    m ? { kind: "merchant", merchantId: m.id } : { kind: "ethoca" }
                  )
                }
                title={`drill into ${a.id}`}
              >
                <div className={styles.itemLeft}>
                  <span className={styles.id}>{a.id}</span>
                  <span className={styles.merchant}>{m?.name ?? a.merchantId}</span>
                  <span className={styles.meta}>
                    card ••{a.cardLast4} · {a.receivedAt}
                  </span>
                </div>
                <div className={styles.itemRight}>
                  <span className={styles.amount}>{fmtEur(a.amountEur)}</span>
                  <span className={styles.status}>
                    {a.status}
                    {a.action ? ` · ${a.action}` : ""}
                  </span>
                  <span className={styles.deadline}>due {a.deadlineAt}</span>
                </div>
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
